import Index from '@/views/buyer/Index.vue';
import settings from '@/router/buyer/setting';
import Favorites from '@/views/buyer/Favorites.vue';
import contact from '@/router/buyer/contact';
import vis from '@/router/buyer/vis';

const defaultRouters: any[] = [];
const children: any[] = defaultRouters
  .concat(settings.routes)
  .concat(contact.routes)
  .concat(vis.routes);

const routes: any[] = [
  {
    path: '/buyer',
    component: Index,
    children: [
      ...children,
      {
        name: 'buyer-favorites',
        path: 'favorites',
        component: Favorites,
        meta: {
          title: 'お気に入りリスト',
          // actor: actors.none,
          // auth: auths.noRequired,
        },
      },

    ],
  },
];

export default {
  routes,
};
